module.exports = "./img/00b9cb2cf3e79c1c2d0009987827ecb1.jpg";